import { useState, useEffect } from 'react'
import { useFadeIn } from '@hooks/useFadeIn'
import { skills, expertise } from '@content/portfolioData'

export function Skills() {
  const fade = useFadeIn()
  const [animated, setAnimated] = useState(false)
  const sectionRef = fade.ref

  useEffect(() => {
    const el = sectionRef.current
    if (!el) return

    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setAnimated(true) },
      { threshold: 0.3 },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [sectionRef])

  return (
    <section id="skills" ref={sectionRef as React.RefObject<HTMLElement>} className={`modern-section ${fade.className}`}>
      <p className="modern-section__label">Skills</p>
      <h2 className="modern-section__title">Technical expertise</h2>
      <div className="modern-skills__grid">
        <div className="modern-skills__bars">
          {skills.map((skill) => (
            <div key={skill.name} className="modern-skill-bar">
              <div className="modern-skill-bar__header">
                <span className="modern-skill-bar__name">{skill.name}</span>
                <span className="modern-skill-bar__label">{skill.label}</span>
              </div>
              <div className="modern-skill-bar__track">
                <div
                  className="modern-skill-bar__fill"
                  style={{ width: animated ? `${skill.level}%` : '0%' }}
                />
              </div>
            </div>
          ))}
        </div>
        <div className="modern-expertise__list">
          {expertise.map((cat) => (
            <div key={cat.category} className="modern-expertise__category">
              <h3>{cat.category}</h3>
              <div className="modern-expertise__items">
                {cat.items.map((item) => (
                  <span key={item} className="modern-expertise__item">{item}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
